<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">CityBD List</h1>
        </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-2">
                    <div class="col-sm-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>
                    <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadCityBdHistory(0,perpage)">
                            <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadCityBdHistory(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Location</th>
                            <th>Date</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of usersList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.location}}</td>
                            <td>{{user.date}}</td>
                            <td>{{user.time}}</td>

                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !usersList.length">
                            <td colspan="20"><i class="far fa-frown"></i> History not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>